import { shape, bool } from 'prop-types';

const ProductAvailabilityIndicator = ({ selectedVariant, productAvailableForSale }) => {
    if (selectedVariant) {
        return selectedVariant.availableForSale ? 'In Stock and Ready to Ship!!!' : 'Out of stock';
    } else {
        return productAvailableForSale ? 'In Stock and Ready to Ship!!!' : 'Currently unavailable';
    }
};

const ProductAvailabilityIndicatorProps = {
    selectedVariant: shape({
        availableForSale: bool.isRequired,
    }),
    productAvailableForSale: bool.isRequired,
};
ProductAvailabilityIndicator.propTypes = ProductAvailabilityIndicatorProps;
export default ProductAvailabilityIndicator;